import { render, staticRenderFns } from "./ParticipantBox.vue?vue&type=template&id=a776a672&scoped=true&"
import script from "./ParticipantBox.vue?vue&type=script&lang=ts&"
export * from "./ParticipantBox.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipantBox.vue?vue&type=style&index=0&id=a776a672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a776a672",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VChip,VImg,VList,VListItem,VMenu,VResponsive})
